import { FBProcedureItemType } from '..';
import { DocumentRevision } from '../../../state/ducks/documentRevisions/types';

export interface FBMPIProcedureSelectValue {
  id?: string
  fieldId: string
  forPreselected: { id: string }
  usedOverride: Partial<DocumentRevision> | string
  type: FBProcedureItemType | 'MATERIAL' | 'EQUIPMENT'
  overrideDocId?: string
  refId?: string
  materialId?: string
  equipmentId?: string
  quantity?: number
  unit?: string
  lotPart?: string
  lotId?: string
  lotDocId?: string
  lotPartRevision?: string
  pmDueDate?: string
  calDueDate?: string
  actualId?: string
  eqStatus?: string
}

export type ProcedureItemType = 'MATERIAL' | 'EQUIPMENT';

export interface FBMPIProcedureSelectEditRequestBody {
  type: ProcedureItemType
  quantity?: number
  unit?: string
}

export enum DOCUMENT_REVISION_LOT_STATUS {
  QUARANTINE = 'QUARANTINE',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
  USE_AS_IS = 'USE_AS_IS',
  RTV = 'RETURN_TO_VENDOR',
  REWORK = 'REWORK',
  SCRAP = 'SCRAP',
  RD_USED_ONLY = 'R&D_USED_ONLY',
  OTHER = 'OTHER',
  VOIDED = 'VOIDED',
}
